import api from 'api'
import useSWR from 'swr'

/**
 * idをもとにOwnerのArtistを取得するSWR
 */
export const useOwnerArtistNames = ({
  ownerId,
  limit,
}: {
  ownerId: string
  limit?: number
}) => {
  const keys =
    ownerId != null ? [`/owners/${ownerId}/artist_names`, limit] : null
  return useSWR<ArtistNameType[]>(
    keys,
    (path: string) =>
      api
        .get(path, {
          params: {
            limit: limit,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            return res.data
          } else throw res
        })
        .catch((err) => {
          throw err
        }),
    {
      revalidateOnFocus: false,
    },
  )
}
